// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-n_fr","galleryThumbnail_active":"c-n_fs","galleryThumbnail__image":"c-n_ft"};